


import { fetchPlanningOrdersByShift } from '@/entities/orders/thunks/fetchPlanningOrdersByShift'
import { selectAllScenariosWithShifts } from '@/entities/schedules'
import { widgetWindowsSelector } from '@/entities/widgetWindows'
import { OperationsGanttWidgetWindow } from '@/entities/widgetWindows/models/WidgetWindow'
import { updateWidgetWindow } from '@/entities/widgetWindows/widgetWindowsSlice'
import { MosaicAdditionalToolbar } from '@/shared/components'
import { DropdownOption } from '@/shared/components/FilterMultiselectDropdown/FilterMultiselectDropdown'
import { useGanttContext } from '@/shared/components/GanttChart/GanttContext'
import { MosaicToolbarMenuItem } from '@/shared/components/MosaicAdditionalToolbar/models/MosaicToolbarMenuItem'
import { useAppDispatch, useAppSelector } from '@/shared/store'
import { faTrash } from '@fortawesome/pro-regular-svg-icons'

import { useOperationsGanttContext } from './OperationsGanttChartContext'

export type PlanningOperationsGanttWidgetToolbarProps = {
  //
}

// TODO: Add an API endpoint to retrieve the list of shifts for the dropdown filter
export const PlanningOperationsGanttWidgetToolbar: React.FC<PlanningOperationsGanttWidgetToolbarProps> = () => {
  const { widgetId } = useOperationsGanttContext()
  const { zoom, setZoom } = useGanttContext()
  const ganttWidget = useAppSelector((state) => widgetWindowsSelector.selectById(state, widgetId))
  const selectedShiftIds = (ganttWidget as OperationsGanttWidgetWindow)?.shiftIds || []
  const dispatch = useAppDispatch()
  const planningScenariosWithShifts = useAppSelector((state) => selectAllScenariosWithShifts(state))

  // Optional TODO: Create an API endpoint to retrieve the list of shifts for the dropdown filter
  const planningShiftOptions: DropdownOption[] = planningScenariosWithShifts.flatMap((scenario) =>
    scenario.shifts.map((shift) => ({ label: `${scenario.name} > ${shift.name}`, value: shift.id })),
  )

  const selectedShiftOptions = selectedShiftIds
    .map((shiftId) => planningShiftOptions.find((option) => option.value === shiftId))
    .filter(option => option !== undefined)

  const handleSelectShift = (val: DropdownOption) => {
    const index = selectedShiftIds.findIndex(id => id === val.value)

    if (index > -1) {
      const newSelectedShiftIds = [...selectedShiftIds]

      newSelectedShiftIds.splice(index, 1)

      dispatch(updateWidgetWindow({
        id: widgetId,
        changes: {
          shiftIds: newSelectedShiftIds,
        },
      }))
    } else {
      const newSelectedShiftIds = [...selectedShiftIds, val.value]

      dispatch(fetchPlanningOrdersByShift({ shiftId: val.value }))
      dispatch(updateWidgetWindow({
        id: widgetId,
        changes: {
          shiftIds: newSelectedShiftIds,
        },
      }))
    }
  }

  const handleClearAllShifts = () => {
    dispatch(updateWidgetWindow({
      id: widgetId,
      changes: {
        shiftIds: [],
      },
    }))
  }

  const toolbarMenuItems: MosaicToolbarMenuItem[] = [
    {
      type: 'multidropdown',
      label: 'Vehicle Shifts',
      values: (selectedShiftOptions as DropdownOption[]),
      options: planningShiftOptions,
      onSelectItem: handleSelectShift,
      searchActionEnable: true,
      searchActionIcon: faTrash,
      slotProps: {
        search: {
          placeholder: 'Search scenario shifts',
        },
        searchAction: {
          onClick: handleClearAllShifts,
          tooltipTitle: 'Clear selected shifts',
          disabled: selectedShiftIds.length === 0,
        },
      },
    },
    {
      type: 'slider',
      label: 'Zoom',
      float: 'right',
      value: zoom,
      min: 0.5,
      max: 7,
      step: 0.5,
      onChange: (_, value) => setZoom(value as number),
    },
  ]

  return (
    <MosaicAdditionalToolbar
      toolbarMenuItems={toolbarMenuItems}
      averageMenuItemWidth={120}
    />
  )
}
